module.exports = __webpack_public_path__ + "assets/img/img7.db7dbfd1.png";